import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Pensé que esto sería otro fracaso de manualidad, pero el sistema de números es infalible. Hice el Lobo Blanco en 2 horas y ahora es el centro de atención de mi oficina. ¡Mis colegas no creen que lo hice yo!',
  name: 'Valeria M.',
  location: 'CDMX',
  result: 'Escultura nivel Pro en su primer intento.'
}, {
  quote: 'Como gamer, quería decorar mi setup pero las figuras de colección son carísimas. Con Sculpt-It hice un T-Rex gigante por menos de $3 USD en materiales. Se ve épico en mis directos.',
  name: 'Santi G.',
  location: 'Bogotá',
  result: 'Setup decorado con $9.99 de inversión.'
}, {
  quote: "Dudaba porque no tengo paciencia, pero el video de 'Acabados de Galería' me enseñó a ocultar las pestañas de pegamento. ¡Parece cerámica! Ya vendí mi primera pieza a una amiga por $40.",
  name: 'Elena R.',
  location: 'Madrid',
  result: 'Recuperó su inversión 4 veces en una semana.'
}];
export function TestimonialsSection() {
  return <section className="py-12 sm:py-24 px-4 bg-background border-y border-white/5" data-id="element-335">
      <div className="max-w-6xl mx-auto" data-id="element-336">
        <div className="text-center mb-10 sm:mb-16" data-id="element-337">
          <h2 className="font-serif text-3xl sm:text-4xl text-text mb-4" data-id="element-338">
            Resultados de Galería,{' '}
            <span className="text-accent italic" data-id="element-339">Hechos en Casa</span>
          </h2>
          <div className="flex justify-center gap-1 text-accent" data-id="element-340">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-341" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-342">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-surface p-8 rounded-2xl border border-white/5 relative flex flex-col h-full" data-id="element-343">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-white/5" data-id="element-344" />

              <div className="flex-grow" data-id="element-345">
                <p className="text-textMuted leading-relaxed mb-6 italic" data-id="element-346">
                  "{t.quote}"
                </p>
              </div>

              <div className="mt-auto pt-6 border-t border-white/5" data-id="element-347">
                <p className="font-medium text-text" data-id="element-348">{t.name}</p>
                <p className="text-sm text-textMuted mb-3" data-id="element-349">{t.location}</p>
                <div className="bg-accent/10 rounded-lg p-3 border border-accent/20" data-id="element-350">
                  <p className="text-sm text-accent font-medium" data-id="element-351">
                    <span className="opacity-70" data-id="element-352">Resultado:</span> {t.result}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}